import { Route, Routes } from "react-router-dom";
import MagicLinkApp from "@/MagicLinkApp";
import { PublicRequestLayout } from "@/Layout/PublicRequestLayout";
import { PublicRouteName, publicRoutes, buildPublicSearchPath } from "@/Router/publicRoutes";
import TokenView from "@/Views/PublicRequest/TokenView";
import SearchView from "@/Views/PublicRequest/SearchView";
import PublicNotFoundView from "@/Views/Public/PublicNotFoundView";
import { RequestMasterTypeEnum } from "@/Schemas/PublicRequest/RequestMasterTypeEnum";

const allowedSearchRoutes = Object.values(RequestMasterTypeEnum)
    .filter((v): v is number => typeof v === "number");

export const PublicAppRouter = () => (
    <Routes>
        <Route
            path={publicRoutes[PublicRouteName.REQUEST_LINK_CONFIRMATION].path}
            element={<MagicLinkApp />}
        />

        <Route element={<PublicRequestLayout />}>
            <Route
                path={publicRoutes[PublicRouteName.PUBLIC_REQUEST_TOKEN].path}
                element={<TokenView />}
            />
            {allowedSearchRoutes.map((id) => (
                <Route
                    path={buildPublicSearchPath(`${id}`)}
                    element={<SearchView requestMasterType={id as RequestMasterTypeEnum} />}
                />
            ))}
        </Route>

        <Route path="*" element={<PublicNotFoundView />} />
    </Routes>
);
